module.exports = __webpack_public_path__ + "static/media/tlyfyeBanner.b3234dbc.png";